import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import { pushEvent } from '../../utils/analytics.js';
import { triggerIntroReveal } from '../App';

import Title from '../../components/navigation/Title'
import Section from '../SectionWrapper'
import Media from '../../components/pageContent/Media'
import Hero from '../../components/hero/Hero.js'
import Stars from '../../components/carousel/Animations/Stars'
import Error from '../../components/pageContent/Error'
import Watermark from '../../components/pageContent/Watermark'
import Loading from '../../components/pageContent/Loading'
import List from '../../components/pageContent/List'
import Showdown from 'showdown'
import Footer from '../../components/footer/Footer.js'

import { getUrl } from '../../utils/services.js'

class Page extends Component {


        constructor(props) {

                super(props)

                this.state = {
                        isLoading: false,
                        isLoaded: false,
                        isError: false,
                        data: {},
                        currentId: null
                }

                this.getData = this.getData.bind(this)

        }

        getData(id) {

                this.setState({
                        isLoading: true
                })

                getUrl(`/api/casestudy/${id}`).then((data) => {

                        this.setState({
                                data: data.fields,
                                isLoading: false,
                                isLoaded: true
                        }, () => {
                                if (this.props.onPageReady) {
                                        this.props.onPageReady();
                                }
                                triggerIntroReveal();
                        })

                }).catch((error) => {

                        this.setState({
                                isLoading: false,
                                isError: true,

                        })

                })

        }

        componentDidMount() {

                pushEvent();
                const { id } = this.props.params
                this.setState({ currentId: id })
                this.getData(id)
        }


        componentDidUpdate(prevProps) {

                if (this.props.params.id !== prevProps.params.id) {
                        console.log('changing cs')
                        window.scrollTo(0, 0)

                        this.setState({
                                isLoaded: false,
                                currentId: this.props.params.id
                        })

                        this.getData(this.props.params.id)
                }


        }



        render() {


                const { data, isLoaded, isLoading, isError } = this.state
                const { viewport } = this.props
                const converter = new Showdown.Converter()

                return (
                        <div>


                                {isError && <Error />}

                                {isLoading && <Loading />}

                                {isLoaded &&

                                        <div>

                                                <Title text={data.project} />

                                                <Watermark txt={data.watermark} viewport={viewport} />

                                                <Hero title={data.project} subtitle={data.description} to={data.url} color="#00aeef" theme="light" viewport={viewport}
                                                        media={false}
                                                        background={
                                                                <Stars viewport={viewport} isActive={true} />
                                                        }
                                                        showScroll={true}
                                                        isCentered={true}
                                                />




                                                <div className="pblg xs-pb0 xs-ptsm">

                                                        <div className="grid">

                                                                <div className="unit one-third xs-p0">

                                                                        {data.features &&

                                                                                <Section>

                                                                                        <List title="Features" items={data.features} className="xs-pbsm" />

                                                                                </Section>

                                                                        }

                                                                </div>


                                                                <div className="unit two-thirds xs-pb0">

                                                                        {data.text &&
                                                                                <div className="mb50 rich-text" dangerouslySetInnerHTML={{ __html: converter.makeHtml(data.text) }} />
                                                                        }

                                                                        {data.media && data.media.map((asset, index) => {
                                                                                return <div key={index} className="xs-ng">
                                                                                        <div className="mb50 xs-mb0">
                                                                                                <Media data={asset} caption={asset.fields.title || ""} />
                                                                                        </div>
                                                                                </div>
                                                                        })}

                                                                </div>

                                                        </div>

                                                </div>



                                                <Footer viewport={viewport / 2} />

                                        </div>



                                }

                        </div>
                );
        }
}

// Wrapper to inject useParams into class component
function CasestudyWithParams(props) {
        const params = useParams();
        return <Page {...props} params={params} />;
}

export default CasestudyWithParams;
